const QUERIES = {
  USERS_LIST: 'users-list',
  ORDENES_LIST: 'ordenes-list',
  PRODUCTOS_LIST: 'productos-list',
  PROMOCIONES_LIST: 'promociones-list',
  EMPRESAS_LIST: 'empresas-list',
  GC_TRACK_USERS_LIST: 'gc-tracker-users-list',
  PANELS_LIST: 'panels-list',
}

const SERVICIOS_API = {
  URL_USUARIOS: '/usuarios',
  URL_PRODUCTOS: '/producto',
  URL_SUCURSAL: '/sucursal',
  URL_FISCALES: '/datosFiscales',
}

const API_URL = process.env.REACT_APP_API_URL

const zonasHorarias = [
  'America/Adak',
  'America/Anchorage',
  'America/Anguilla',
  'America/Antigua',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Aruba',
  'America/Asuncion',
  'America/Atikokan',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Cayenne',
  'America/Cayman',
  'America/Chicago',
  'America/Chihuahua',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Dominica',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Fort_Nelson',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Kralendijk',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Lower_Princes',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Marigot',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/Montserrat',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Sitka',
  'America/St_Barthelemy',
  'America/St_Johns',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Tortola',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
]

const SIGNAL_OPTIONS = [
  // {value: '', label: 'Señal', disabled: true, selected: true},
  {value: '1', label: '1️⃣ Normalmente Cerrado'},
  {value: '0', label: '0️⃣ Normalmente Abierto'},
]

const NOTIFICATION_TYPE_OPTIONS = [
  // {value: '', label: 'Tipo de Notificación', disabled: true},
  {value: 'Alerta', label: '🚨 Alerta'},
  {value: 'Advertencia', label: '⚠️ Advertencia'},
  {value: 'Normal', label: '🔔 Normal'},
  {value: 'Solo lectura', label: '📄 Solo Lectura'},
]

const NOTIFICATION_TAG_OPTIONS = [
  // {value: '', label: 'Tipo de Notificación', disabled: true},
  {value: 'Alerta', label: '🚨 Alerta'},
  {value: 'Advertencia', label: '⚠️ Advertencia'},
  {value: 'Normal', label: '🔔 Normal'},
  {value: 'Solo lectura', label: '📄 Solo Lectura'},
  {value: 'Abierto', label: '0️⃣ Abierto'},
  {value: 'Cerrado', label: '1️⃣ Cerrado'},
  {value: 'Encendido', label: '🔆 Encendido'},
  {value: 'Apagado', label: '🌑 Apagado'},
]

const MEASURE = [
  {value: 'PSI', label: '💨 PSI'},
  {value: 'Milivolts', label: '⚡️ Milivolts'},
]

export {
  QUERIES,
  SERVICIOS_API,
  zonasHorarias,
  API_URL,
  SIGNAL_OPTIONS,
  NOTIFICATION_TYPE_OPTIONS,
  NOTIFICATION_TAG_OPTIONS,
  MEASURE,
}
